import Vue from 'vue'
import Router from 'vue-router'
import Getcode from '@/components/getcode/index'
import Binding from '@/components/binding/index'
import Mine from '@/components/mine/index'
import Pay from '@/components/recharge/pay'
import Agree from '@/components/binding/agree'
import Refund from '@/components/refund/refund'

Vue.use(Router)

export default new Router({
	mode: 'history',
	routes: [
		{
			path: '*',
			redirect: '/card/getcode',
		},
		{
			path: '/card/getcode',
			name: 'Getcode',
			component: Getcode
		},
		{
			path: '/card/binding',
			name: 'Binding',
			component: Binding,
			children: [
				{ 
					path: '/card/agree', 
					component: Agree ,
				}
			]
		},
		{
			path: '/card/mine',
			name: 'Mine',
			component: Mine
		},
		{
			path: '/card/recharge/pay',
			name: 'Pay',
			component: Pay
		},
		{
			path: '/card/refund',
			name: 'Refund',
			component: Refund
		}
	]
})



// WEBPACK FOOTER //
// ./src/router/index.js